import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip
} from '@mui/material';
import {
  Close as CloseIcon,
  AccountTree as LogicIcon,
  Visibility as VisibilityIcon,
  CallSplit as BranchIcon,
  SkipNext as SkipIcon,
  Settings as SettingsIcon,
  Email as EmailIcon
} from '@mui/icons-material';

const ComingSoonDialog = ({ open, onClose, feature = "Logic Rules" }) => {
  const handleContactSupport = () => {
    const subject = encodeURIComponent(`${feature} Feature Suggestions`);
    const body = encodeURIComponent(
      `Hi SurveySlack team,\n\nI'm interested in the upcoming ${feature} feature. Here are my suggestions or use cases:\n\n[Please share your ideas here]\n\nThanks!`
    );
    window.open(`mailto:support@surveyslack.com?subject=${subject}&body=${body}`, '_blank');
    onClose();
  };

  const features = [
    {
      icon: <VisibilityIcon />,
      text: "Show/hide questions based on previous answers"
    },
    {
      icon: <BranchIcon />,
      text: "Create branching survey paths"
    },
    {
      icon: <SkipIcon />,
      text: "Skip irrelevant sections automatically"
    },
    {
      icon: <SettingsIcon />,
      text: "Build complex conditional flows"
    }
  ];

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LogicIcon color="primary" />
            <Typography variant="h6">
              {feature}
            </Typography>
            <Chip 
              label="Coming Soon" 
              color="primary" 
              size="small" 
              sx={{ ml: 1 }}
            />
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
          🚀 We're working on an advanced logic system that will make your surveys more intelligent and user-friendly!
        </Typography>

        <Typography variant="subtitle2" gutterBottom sx={{ mb: 2, fontWeight: 600 }}>
          What you'll be able to do:
        </Typography>

        <List dense sx={{ mb: 3 }}>
          {features.map((feature, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                {React.cloneElement(feature.icon, { 
                  fontSize: 'small', 
                  color: 'primary' 
                })}
              </ListItemIcon>
              <ListItemText 
                primary={feature.text}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          ))}
        </List>

        <Box sx={{ 
          p: 2, 
          bgcolor: 'primary.lighter', 
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'primary.light'
        }}>
          <Typography variant="body2" color="primary.dark">
            💡 Have specific use cases or suggestions for this feature? We'd love to hear from you!
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        <Button 
          onClick={handleContactSupport}
          variant="contained"
          startIcon={<EmailIcon />}
        >
          Share Suggestions
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComingSoonDialog;